/** @type {Record<string, string[]>} */
export const LANDING_HIGHLIGHTS_BY_LOCALE = {
  nl: [
    "Zaagbreedte (kerf) in de indeling",
    "Meerdere deelprojecten in één plan",
    "Restmateriaal vóór nieuwe platen",
    "PDF-werkplan voor bouwmarkt of zaagservice",
  ],
  en: [
    "Kerf width included in the layout",
    "Multiple subprojects in one plan",
    "Offcut stock before new sheets",
    "PDF work plan for hardware store or cutting service",
  ],
};
